module.exports = __webpack_public_path__ + "img/resized-APP-0016-1.90416521.png";